import { Preloader } from "./Preloader.js";

export interface StageOptions {
    element: HTMLDivElement;
    width?: number;
    height?: number;
    elementOffsetHeight?: number;
    className?: string;
    layout?: StageLayout;
    assetsUrl: string;
    lottieUrl?: string;
}

export type StageLayout = "fixed" | "responsive";

export class Stage {

    public readonly element: HTMLDivElement;
    public readonly background: HTMLDivElement;
    public readonly content: HTMLDivElement;
    public readonly foreground: HTMLDivElement;
    public readonly overlay: HTMLDivElement;
    public readonly cover: HTMLDivElement;
    public readonly preloader: Preloader;

    private _elementOffsetHeight: number;

    constructor(options: StageOptions) {

        options = e5.object.merge({
            width: 1920,
            height: 1080,
            elementOffsetHeight: 0,
            layout: "fixed",
            lottieUrl: options.assetsUrl + "/emojis/musical-notes.json"
        } as StageOptions, options);

        this.resize();

        this.element = options.element;
        this._elementOffsetHeight = options.elementOffsetHeight;

        this.element.classList.add("stage", "base--gradient");
        this.element.classList.add("stage--layout-" + options.layout);

        if (options.className) {
            this.element.classList.add(options.className);
        }

        this.element.innerHTML = `
        <div class="stage__layer stage__layer--background"></div>
        <div class="stage__layer stage__layer--content"></div>
        <div class="stage__layer stage__layer--foreground"></div>
        <div class="stage__layer stage__layer--overlay"></div>
        <div class="stage__layer stage__layer--cover"></div>
        `;

        this.background = this.element.querySelector(".stage__layer--background");
        this.content = this.element.querySelector(".stage__layer--content");
        this.foreground = this.element.querySelector(".stage__layer--foreground");
        this.overlay = this.element.querySelector(".stage__layer--overlay");
        this.cover = this.element.querySelector(".stage__layer--cover");

        this.preloader = new Preloader({
            container: this.cover,
            lottieUrl: options.lottieUrl
        });

        if (options.layout === "fixed") {
            // this.element.style.width = this._width + "px";
            // this.element.style.height = this._height + "px";
        }

        window.addEventListener("resize", () => this.resize());
    }

    private resize(): void {
        const w = window.innerWidth;
        const h = window.innerHeight;
        const elementWidth = 1920;
        const elementHeight = 1080;
        const scale = Math.max(Math.min(w / elementWidth, h / elementHeight), 0.05);

        if (scale === 1) {
            document.documentElement.setAttribute("data-scale", "fit");
        } else if (scale > 1) {
            document.documentElement.setAttribute("data-scale", "up");
        } else if (scale < 1) {
            document.documentElement.setAttribute("data-scale", "down");
        }

        document.documentElement.style.setProperty("--stage-scale", scale + "");
        // document.documentElement.style.setProperty("--stage-transform", (scale === 1 ? "none" : `scale(${scale})`));
        // document.documentElement.style.setProperty("--stage-scale-clamped", Math.min(scale, 1) + "");
        // document.documentElement.style.setProperty("--stage-scale-inverse", (1 / scale) + "");
    }

    public setNavState(state: "home" | "detail" | "media"): void {
        this.element.querySelector(`.stage__nav-button[data-action="home"]`)
            .classList.toggle("e5-hidden", state === "home");
        this.element.querySelector(`.stage__nav-button[data-action="back"]`)
            .classList.toggle("e5-hidden", state !== "media");
    }
}